import React, { Component } from 'react'
import { Icon } from './primitives.components'
export class ExpandableContainer extends Component {
  constructor() {
    super()
    this.state = { isOpen: false }
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
      this.toggleExpandable()
    }
  }

  toggleExpandable() {
    this.setState({ isOpen: !this.state.isOpen })
  }
  childFactory(child) {
    let component = null
    if (child.type === ExpandableContainer.Header) {
      component = React.cloneElement(child, {
        isOpen: this.state.isOpen,
        onClick: this.props.onClick ? e => this.props.onClick(e) : () => this.toggleExpandable(),
        key: 'header',
      })
    } else if (child.type === ExpandableContainer.Content) {
      component = React.cloneElement(child, { isOpen: this.state.isOpen, key: 'content' })
    }
    return component
  }

  static Header(props) {
    return (
      <div
        onClick={props.onClick}
        className={`expandable__header ${props.className ? props.className : ''}`}
      >
        <div className="expandable__header-text">
          {props.children}
        </div>
        <Icon
          iconName="arrow"
          className={`expandable__header-icon ${props.isOpen ? 'open' : ''}`}
          size="8"
        />
      </div>
    )
  }

  static Content(props) {
    return (
      <div className={`expandable__content ${props.isOpen ? 'expanded' : 'collapsed'}`}>
        {props.children}
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.children.map(child => this.childFactory(child))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/expandable.container.js